import { useState } from 'react';
import PanelLayout from '../components/PanelLayout';
import { favoritesList } from '@/mocks/therapistPanel';

export default function FavorilerPage() {
  const [items, setItems] = useState(favoritesList);

  const removeFav = (id: number) => {
    setItems((prev) => prev.filter((f) => f.id !== id));
  };

  return (
    <PanelLayout>
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500">Favorilerim</h1>
          <p className="text-sm text-gray-500 mt-1">
            Favoriye aldığınız işletmeler. Karşı tarafa favori bildirimi gitmez.
          </p>
        </div>

        <div className="bg-dark-teal-50 border border-dark-teal-100 rounded-xl p-4 mb-6 flex items-start gap-3">
          <span className="w-5 h-5 flex items-center justify-center text-dark-teal-500 shrink-0 mt-0.5">
            <i className="ri-information-line text-base" />
          </span>
          <p className="text-xs text-dark-teal-600">
            Favoriye aldığınız işletmeler size bildirim almaz. Sadece sizin referans listenizde kalır.
          </p>
        </div>

        <div className="space-y-4">
          {items.map((fav) => (
            <div
              key={fav.id}
              className={`bg-white rounded-xl border p-5 ${fav.isActive ? 'border-gray-100' : 'border-gray-100 opacity-70'}`}
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-sm font-semibold text-deep-navy-500">{fav.spaType}</span>
                    {!fav.isActive && fav.closedLabel && (
                      <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-gray-100 text-gray-500">
                        {fav.closedLabel}
                      </span>
                    )}
                  </div>
                  <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-500">
                    <span className="flex items-center gap-1">
                      <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-map-pin-line" /></span>
                      {fav.city}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-time-line" /></span>
                      {fav.workModel}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-4 h-4 flex items-center justify-center text-gray-400"><i className="ri-money-cny-circle-line" /></span>
                      {fav.salaryBand}
                    </span>
                    <span className="flex items-center gap-1 text-dark-teal-500 font-medium">
                      <span className="w-4 h-4 flex items-center justify-center"><i className="ri-star-line" /></span>
                      {fav.expertise}
                    </span>
                  </div>
                </div>
                <button
                  onClick={() => removeFav(fav.id)}
                  className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-red-50 text-gray-300 hover:text-red-500 transition-colors cursor-pointer shrink-0"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-heart-3-fill text-lg" />
                  </span>
                </button>
              </div>
            </div>
          ))}
        </div>

        {items.length === 0 && (
          <div className="text-center py-16">
            <span className="w-12 h-12 flex items-center justify-center mx-auto text-gray-300 mb-3">
              <i className="ri-heart-3-line text-3xl" />
            </span>
            <p className="text-sm text-gray-500">Henüz favori işletme eklemediniz.</p>
          </div>
        )}
      </div>
    </PanelLayout>
  );
}